// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2Ce79","primary":"Button_primary__10Br9","secondary":"Button_secondary__3eSk5","new":"Button_new__2Bpeq"};